/**
 * photoEnqueueFailures — FT-577 (2026-11-01).
 *
 * Tracks photos that were SAVED on this device but whose upload note could NOT
 * be written to the outbox (base64 conversion or outbox write failed). Before
 * FT-577 this was only logged via devWarn (a no-op in production), so the user
 * saw nothing. Now it is recorded here and surfaced by the header sync badge.
 *
 * In-memory on purpose: the photo itself is safe in IDB, and the boot-time
 * safety net (photoPullMerge.reconcileVesselPhotos) re-queues any local photo
 * that has no outbox entry on the next app start — which also clears it here.
 */

const failures = new Map(); // photoId -> { message, at }

export const OUTBOX_STATUS_EVENT = 'outboxStatusChanged';

const notify = () => {
  try {
    window.dispatchEvent(new CustomEvent(OUTBOX_STATUS_EVENT, { detail: { source: 'photo-enqueue' } }));
  } catch { /* non-browser env */ }
};

export const recordPhotoEnqueueFailure = (photoId, message) => {
  if (!photoId) return;
  failures.set(photoId, { message: message || null, at: Date.now() });
  notify();
};

export const clearPhotoEnqueueFailure = (photoId) => {
  if (failures.delete(photoId)) notify();
};

export const getPhotoEnqueueFailureCount = () => failures.size;

/** Test hook. */
export const __resetPhotoEnqueueFailures = () => failures.clear();
